import { withStyles } from '@material-ui/core/styles';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import React from 'react';
import { globalStyles, gstheme } from './style/gstheme';
import PropTypes from 'prop-types';

const styles = theme => {
    return Object.assign({
        activeButton: {
            backgroundColor: gstheme.palette.primary.main,
            color: 'white',
            textAlign: 'center',
            borderRadius: '50%',
            padding: '4px 10px',
            fontSize: '18px'
        },
        numberedButton: {
            border: 'solid 1px ' + theme.palette.text.disabled,
            textAlign: 'center',
            borderRadius: '50%',
            color: theme.palette.text.disabled,
            padding: '4px 10px',
            fontSize: '18px'
        }
    }, globalStyles);
};

function CustomStepIcon(props) {

    const stepClass = props.index === props.activeStep ? props.classes.activeButton : props.classes.numberedButton;
    const completed = props.completed

    return (
        completed ?
            <div style={{ width: '43px', height: '41px' }}>
                <CheckCircleIcon fontSize="large" style={{ marginTop: 2, color: gstheme.palette.secondary.main }} />
            </div>
            :
            <div className={stepClass}>{props.index + 1}</div>
    );
}

CustomStepIcon.propTypes = {
    index: PropTypes.number.isRequired,
    activeStep: PropTypes.number.isRequired,
    classes: PropTypes.object,
    completed: PropTypes.bool
};

export default withStyles(styles)(CustomStepIcon);